import React, { useState, useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Profile } from '../views/Account';
import { HomeNavbar } from '../components/Navbars';
import { MainFooter } from '../components/Footers';
import { MainSidebar } from '../components/Sidebar';
import * as actions from '../redux/actions';
import { Loading } from '../components/Loading';
import { NotFound } from '../components/Error';
import accessRight from '../utils/functions/accessRight';
import ReportGold from '../views/Gold/ReportGold';
import { HistoryBuy } from 'views/Gold';
import DetailOrderGoldCash from '../views/Gold/DetailOrderGoldCash';
import DetailReportGold from '../views/Gold/DetailReportGold';
import EditOrderReportGold from '../views/Gold/EditOrderReportGold';
import DetailTransactionReport from '../views/Gold/DetailTransactionReport';

export function Accounting() {
  const module = 'Accounting';
  const prefix = '/accounting';
  const name = 'การบัญชี';
  const dispatch = useDispatch();
  const me = useSelector((state) => state.me);
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };

  useEffect(() => {
    dispatch(actions.meGet());
    dispatch(actions.informationAll());

    return () => {};
  }, []);

  if (!me.userData) {
    return <Loading />;
  }
  if (accessRight(me, module)) {
    return (
      <div className="min-h-screen">
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
        />
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <div className="lg:ml-64  min-h-screen  pt-16 px-8 ">
          <div className="py-4">
            <Switch>
              {/* <Redirect exact from={`${prefix}`} to={`${prefix}`} /> */}
              <Route exact path={`${prefix}`}>
                <HistoryBuy title={'รายการซื้อ-ขาย'} subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/report`}>
                <ReportGold title={'รายงานซื้อขายส่งบัญชี'} subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/edit/:id`}>
                <EditOrderReportGold
                  title="แก้ไขรายงานซื้อขายส่งบัญชี"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/history/detail/cash/:id`}>
                <DetailOrderGoldCash title="รายการซื้อ-ขาย" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/reportTransaction/detail/:id`}>
                <DetailTransactionReport
                  title="รายการซื้อ-ขาย"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/report/detail/:id`}>
                <DetailReportGold
                  title="รายละเอียดรายงานซื้อขายส่งบัญชี"
                  subtitle={name}
                />
              </Route>
              <Route path="*">
                <NotFound />
              </Route>
            </Switch>
          </div>
        </div>
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    );
  }
  return <></>;
}

export default Accounting;
